import {resolvedFuture} from 'external/dev_april_corgi+/js/common/futures';
import * as corgi from 'external/dev_april_corgi+/js/corgi';

import {fetchData} from './data';
import {GRAPH_DIRTIED, SAVE} from './events';
import {GraphElement} from './graph_element';
import {GraphEditorController, State} from './graph_editor_controller';
import {setTitle} from './header';
import {Menubar} from './menubar';

export function GraphEditorPage(
  props: {graphId: string},
  state: State | undefined,
  updateState: (newState: State) => void,
) {
  if (!state) {
    state = {
      currentUser: fetchData('petri.PetriService/GetCurrentUser', {}),
      graphName: 'Untitled',
      saveState: 'clean',
    };
  }
  const futures = [state.currentUser];
  if (futures.filter(f => !f.finished).length > 0) {
    Promise.all(futures).then(() => {
      updateState({
        ...state,
        currentUser: resolvedFuture(state.currentUser.value()),
      });
    });

    return <div>Loading...</div>;
  }

  setTitle(state.graphName);

  return (
    <div
      className="flex flex-col h-full w-full"
      js={corgi.bind({
        controller: GraphEditorController,
        args: props,
        key: props.graphId,
        state: [state, updateState],
        events: {
          corgi: [
            [GRAPH_DIRTIED, 'graphDirtied'],
            [SAVE, 'save'],
          ],
          render: 'wakeup',
        },
      })}
    >
      <Menubar graphName={state.graphName} saveState={state.saveState} />
      <GraphElement key={props.graphId} ref="graph" className="grow w-full" />
    </div>
  );
}
